import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MoveDownSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MoveDownSVG;
